/**
 * ExternalRedirect — PRI-512: About-section content moved to the www marketing
 * site (Astro). The app (app.primateintelligence.ai) is product-surface only;
 * old in-app content URLs hard-redirect to their www home so no inbound link
 * ever dead-ends.
 *
 * Uses window.location.replace so the app URL doesn't pollute history.
 */
import { useEffect } from 'react';
import { useParams } from 'react-router';

export const MARKETING_SITE = 'https://www.primateintelligence.ai';

export default function ExternalRedirect({ to }: { to: string }) {
  const params = useParams();
  useEffect(() => {
    // Substitute route params (e.g. /blog/:slug → /blog/<slug>)
    let target = to;
    for (const [key, value] of Object.entries(params)) {
      if (value) target = target.replace(`:${key}`, value);
    }
    window.location.replace(`${MARKETING_SITE}${target}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
